import { Upload } from 'lucide-react';

interface MediaUploadAreaProps {
  id: string;
  label: string;
  accept: string[];
  isLoading: boolean;
  isDisabled: boolean;
  maxReachedMessage?: string;
  loadingMessage: string;
  loadingColor: 'blue' | 'green';
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MediaUploadArea = ({
  id,
  label,
  accept,
  isLoading,
  isDisabled,
  maxReachedMessage,
  loadingMessage,
  loadingColor,
  onChange,
}: MediaUploadAreaProps) => {
  const colorClasses = {
    blue: {
      border: 'border-blue-500',
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      spinner: 'border-blue-600',
      progressBg: 'bg-blue-200',
      progressBar: 'bg-blue-600',
    },
    green: {
      border: 'border-green-500',
      bg: 'bg-green-50',
      text: 'text-green-600',
      spinner: 'border-green-600',
      progressBg: 'bg-green-200',
      progressBar: 'bg-green-600',
    },
  };

  const colors = colorClasses[loadingColor];

  return (
    <div>
      {isLoading ? (
        <div className={`w-full px-4 py-3 border-2 ${colors.border} ${colors.bg} rounded-xl`}>
          <div className="flex items-center justify-center gap-3">
            <div className={`animate-spin rounded-full h-5 w-5 border-b-2 ${colors.spinner}`}></div>
            <span className={`text-sm ${colors.text} font-medium`}>{loadingMessage}</span>
          </div>
          <div className={`mt-2 w-full ${colors.progressBg} rounded-full h-1.5`}>
            <div className={`${colors.progressBar} h-1.5 rounded-full animate-pulse w-3/5`}></div>
          </div>
        </div>
      ) : (
        <>
          <label
            htmlFor={id}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-colors cursor-pointer"
          >
            <Upload className="w-5 h-5 text-gray-400" />
            <span className="text-sm text-gray-600">{label}</span>
          </label>
          <input
            id={id}
            type="file"
            accept={accept.join(',')}
            onChange={onChange}
            className="hidden"
            disabled={isDisabled}
          />
          {maxReachedMessage && <p className="text-xs text-red-600 mt-2 text-center">{maxReachedMessage}</p>}
        </>
      )}
    </div>
  );
};
